export default {
  applyFilters: "Apply",
  addNew: "Add New",
  addNewAccount: "Add New Account",
  addNewUser: "Add New User",
  addNewPlan: "Add New Plan",
  addNewPlanShort: "Add Plan",
  addScenario: "Add Scenario",
  addNewPage: "Add New Page",
  addNewProjectOutputLayout: "Add New Project Output Layout",
  addNewWidget: "Add New Widget",
  addWidget: "Add Widget",
  addFlight: "Add Flight",
  addNewMetric: "Add New Metric",
  buttonResetPassword: "Reset Password",
  buttonSignIn: "Sign in",
  runComparison: "Run Comparison",
  btnRemoveLogo: "Delete the logo",
  ok: "Ok",
  cancel: "Cancel",
  create: "Create",
  confirm: "Confirm",
  makePublic: "Make Public",
  citiesNZipsBtn: "Cities and ZIPs",
  delete: "Delete",
  defaults: "Defaults",
  editLayout: "Edit Layout",
  editUser: "Edit User",
  editInput: "Edit Input",
  generatePlan: "Generate Plan",
  backToProject: "Back",
  next: "Next",
  only: "Only",
  yes: "Yes",
  proceed: "Proceed",
  select: "Select",
  requestPasswordReset: "Request Password Reset",
  resend: "Resend",
  reset: "Reset",
  invite: "Invite",
  recalculate: "Recalculate",
  persistChanges: "Persist Changes",
  applyChanges: "Apply Changes",
  import: "Import",
  save: "Save",
  saveInfo: "Save Info",
  skip: "Skip",
};
